<div class="min-h-screen flex items-center justify-center">
  <div class="w-full absolute top-0 left-0 p-4 flex justify-between items-center">
    <img alt="Atlas Copco logo" height="80" ngSrc="images/logo.png" priority width="180" />
    <a
      class="inline-flex items-center px-6 py-3 text-primary rounded-md border border-primary hover:bg-primary hover:text-white transition-colors duration-300 ease-in-out"
      href="https://www.atlascopcorental.com/">
      Go to Atlas Copco
    </a>
  </div>
  <div class="text-center p-8 flex flex-col items-center space-y-6">
    <lucide-icon class="w-24 h-24 text-secondary mx-auto" [name]="icon" />
    <h1 class="text-6xl font-bold text-text-primary">404 <span class="text-text-secondary">| Page Not Found</span></h1>
  </div>
</div>
